import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { DataService } from '../../data.service';

/**
 *  KÉZBESÍTÉSI NAPLÓ – hol tart a kiküldött irat?
 *
 *  A küldés eddig egy pillanat volt, nem folyamat: a postakönyvben annyi látszott, hogy
 *  „elküldve", és ha megjött a letöltési igazolás, a státusz csendben átbillent. Hogy
 *  mikor adtuk fel, mikor töltötte le a címzett, és MELYIK igazolás szól róla – az sehol
 *  nem látszott. A hivatali kapun épp ez a lényeg: az igazolás a kézbesítés bizonyítéka.
 *
 *  Itt küldeményenként látszik az életút. Egy helyen, csatornától függetlenül: hivatali
 *  kapu, e-mail, papír – és a SULINFORM üzenetkezelőjéből kiküldött üzenet is, mert a
 *  feladó ugyanazt kérdezi róla („elment-e, elolvasták-e?").
 */
@Component({
  selector: 'app-ikt-kezbesites',
  templateUrl: './kezbesites.component.html',
  styleUrls: ['../iktatgato-layout/iktatgato-layout.component.scss'],
})
export class IktKezbesitesComponent implements OnInit, OnDestroy {
  sajatIntezmeny: any;
  felhasznalo = '';

  kuldemenyek: any[] = [];
  esemenyNevek: any = {};
  forras = '';
  kereses = '';
  napok = 90;
  toltodik = false;
  nyitott: Record<string, boolean> = {};
  private keresoTimer: any = null;

  readonly forrasok = [
    { kulcs: '', nev: 'Mind' },
    { kulcs: 'hivatali_kapu', nev: 'Hivatali kapu' },
    { kulcs: 'email', nev: 'E-mail' },
    { kulcs: 'papir', nev: 'Papír' },
    { kulcs: 'uzenet', nev: 'Sulinform-üzenet' },
  ];

  constructor(private http: HttpClient, private data: DataService,
              private router: Router, private route: ActivatedRoute) {}

  async ngOnInit() {
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    const user = await this.data.getFromStorage('user');
    this.felhasznalo = String(user?.username || user?.adid || '');
    //  A postakönyvből egy konkrét küldeményre szűrve érkezünk.
    const q = this.route.snapshot.queryParamMap.get('q');
    if (q) this.kereses = q;
    await this.betolt();
  }

  ngOnDestroy() { if (this.keresoTimer) clearTimeout(this.keresoTimer); }

  private get int() { return String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, ''); }

  async betolt() {
    this.toltodik = true;
    try {
      const p = new URLSearchParams({ felhasznalo: this.felhasznalo, napok: String(this.napok) });
      if (this.forras) p.set('forras', this.forras);
      if (this.kereses) p.set('q', this.kereses);
      const r: any = await firstValueFrom(this.http.get<any>(`/api/kezbesites/lista/${this.int}?${p.toString()}`));
      this.kuldemenyek = r?.kuldemenyek || [];
      this.esemenyNevek = r?.esemeny_nevek || {};
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A napló betöltése nem sikerült.', 'error');
    }
    this.toltodik = false;
  }

  keresesValtozott() {
    if (this.keresoTimer) clearTimeout(this.keresoTimer);
    this.keresoTimer = setTimeout(() => this.betolt(), 350);
  }

  nyit(k: any) { this.nyitott[k.kulcs] = !this.nyitott[k.kulcs]; }

  /** A küldemény jelenlegi állapota – a postakönyv státusza, emberi néven. */
  allapotNev(k: any): string {
    return ({
      elokeszitve: 'előkészítve', feladasra_var: 'feladásra vár', elkuldve: 'elküldve',
      atveve: 'átvéve', meghiusult: 'meghiúsult', visszahivva: 'visszahívva',
      hiba: 'hiba', reszben_olvasva: 'részben elolvasva',
    } as any)[k?.statusz] || k?.statusz || '–';
  }

  allapotSzin(k: any): string {
    return ({
      atveve: 'success', meghiusult: 'danger', hiba: 'danger',
      visszahivva: 'warning', elkuldve: 'primary', reszben_olvasva: 'tertiary',
    } as any)[k?.statusz] || 'medium';
  }

  forrasNev(f: string): string {
    return (this.forrasok.find((x) => x.kulcs === f) || { nev: f }).nev;
  }

  esemenySzin(e: any): string { return this.esemenyNevek?.[e?.esemeny]?.szin || 'medium'; }

  /** A bizonyító igazolás PDF-je – ugyanaz a fájl, amit a postafiókból letöltöttünk. */
  igazolasUrl(e: any) { return `/api/iktatgato/bksz-bejovo/fajl/${e.bejovo}`; }
  igazolasNyit(e: any) { if (e?.bejovo) this.data.megnyitFajl(this.igazolasUrl(e), 'Igazolás'); }

  iratra(k: any) { if (k?.irat) this.router.navigateByUrl('/iktatgato/irat/' + k.irat); }
}
